const promoCodeConstants = {
  PROMO_VOUCHER_CODE_ADD_STARTED: "PROMO_VOUCHER_CODE_ADD_STARTED",
  PROMO_VOUCHER_CODE_ADD_SUCCESS: "PROMO_CODE_ADD_SUCCESS",
  PROMO_VOUCHER_CODE_ADD_FAILED: "PROMO_VOUCHER_CODE_ADD_FAILED",
  PROMO_CODE_REMOVE_STARTED: "PROMO_CODE_REMOVE_STARTED",
  PROMO_VOUCHER_REMOVE_STARTED: "PROMO_VOUCHER_REMOVE_STARTED",
  PROMO_CODE_REMOVE_SUCCESS: "PROMO_CODE_REMOVE_SUCCESS",
  PROMO_VOUCHER_REMOVE_SUCCESS: "PROMO_VOUCHER_REMOVE_SUCCESS",
  PROMO_CODE_REMOVE_FAILED: "PROMO_CODE_REMOVE_FAILED",
  PROMO_VOUCHER_REMOVE_FAILED: "PROMO_VOUCHER_REMOVE_FAILED",
  PROMO_CLEAR_FIELD: "PROMO_CLEAR_FIELD",
  PROMO_RESET_ERR: "PROMO_RESET_ERR",
}

export default promoCodeConstants
